import siteRequest from '../../helpers/siteRequest';

const StatsRequest = () => {
    return { type: 'STATS_REQUEST' };
};

const StatsSuccess = stats => {
    return { type: 'STATS_SUCCESS', stats };
};

const StatsFailure = error => {
    return {
        type: 'STATS_FAILURE',
        error
    };
};

const stats = () => async dispatch => {
    try {
        dispatch(StatsRequest());

        const response = await siteRequest({
            method: 'get',
            url: '/wp-json/hamyar-faq/v1/stats'
        });

        dispatch(StatsSuccess(response.data));

        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(StatsFailure(error));
    }
};

export { StatsRequest, StatsSuccess, StatsFailure, stats };
